<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header v-if="is_god">
                <i class="icon-menu mr-1"></i>Поиск по путевкам
            </b-card-header>
            <b-card-body>
                <div id="vouchers">

                    <b-row>
                        <b-col>
                            <b-form>
                                <b-form-group label="Имя, телефон, e-mail: " :label-cols="3" :horizontal="false">
                                    <div class="input-group">
                                        <b-form-input v-model="contactsFilter" @input="throttle(1, 2007, applyContactsFilter)" />
                                        <b-button type="button" variant="secondary"  @click='resetContacts()'><i class="cui-circle-x icon"></i> </b-button>
                                    </div>
                                </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>


                    <v-server-table :url="apiurl('voucher/search')"  :columns="columns" :options="options" :theme="theme" id="vouchersTable" ref="vouchersTable"   >

                         <span slot="person" slot-scope="props">
                            <strong v-if="!props.row.customer_id">
                                {{ props.row.contact_name }}
                            </strong>
                            <strong v-if="props.row.customer_id">
                                {{ customerTitle(props.row.customer) }}
                                <small v-if="customerSubtitle(props.row.customer)"><br/>{{ customerSubtitle(props.row.customer) }}</small>
                            </strong>
                            <template v-for="guest in  props.row.guests">
                                <small><br/>{{ guest.surname }} {{ guest.name_ }} {{ guest.patro }}</small>
                            </template>
                        </span>

                        <span slot="hotel" slot-scope="props">
                            <template v-if="is(props.row.hotel)"><strong>{{ props.row.hotel.title }}</strong><br></template>
                            <template v-if="is(props.row.city)"><small>{{ props.row.city.title }}</small></template>
                        </span>

                    </v-server-table>
                </div>
            </b-card-body>
        </b-card>

    </div>
</template>

<script>

    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import VueJsonPretty from 'vue-json-pretty'
    import date_end_iso  from '../jsx/vouchers/date_end_iso'
    import contact_name  from '../jsx/vouchers/contact_name'
    import ag_invoice_number from '../jsx/vouchers/ag_invoice_number'
    import summa_full from '../jsx/vouchers/summa_full'
    import summa_fact_payment from '../jsx/vouchers/summa_fact_payment'
    import status_index from '../jsx/vouchers/status_index'
    import company_and_user from '../jsx/vouchers/company_and_user'
    import comments from '../jsx/vouchers/comments'
    import {CONSTANTS} from '@/constants';
    import { functions_customers } from '@/functions_customers.js';
    //import { setupCalendar, DatePicker } from 'v-calendar'
    //import 'v-calendar/lib/v-calendar.min.css'

    Vue.use(ServerTable)

    const today = new Date()

//    setupCalendar({
//        firstDayOfWeek: 2, // Monday
//        datePickerShowDayPopover: false,
//        showLinkedButtons:true,
//    })


    export default {
        name: 'NsbAgentSearch',
        components: {
            ServerTable,
            Event,
            VueJsonPretty,
         },
        mixins: [functions,functions_customers],
        data: function () {
            return {
                contactsFilter:null,

                data:[],
                columns: ['id', 'date_end_iso', 'person', 'hotel', 'company_and_user', 'comments', 'status_index', ],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        date_end_iso: 'даты',
                        company_and_user: 'агент/агентство',
                        comments: 'комментарий',
                        person: 'заказчик/туристы',
                        hotel: 'объект/город',
                        status_index: 'Статус',
                    },
                    templates: {
                        ag_invoice_number,
                        date_end_iso,
                        status_index,
                        company_and_user,
                        comments
                    },
                    sortable: [],
                    dateColumns:[],
                    filterable: [ ],
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    customFilters: [
                        'contacts',
                    ],
                    perPageValues:[],

                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,

                },
                theme: 'bootstrap4',
                template: 'default',
                deleteModal: false,
                voucherIdToDelete:null,
                deletedVoucherId:null,
            }
        },
        methods: {

            applyContactsFilter: function() {
                console.log('applyContactsFilter');
                this.saveFilter();
                console.log('applyContactsFilter2');
                Event.$emit('vue-tables.filter::contacts', this.contactsFilter);
                console.log('applyContactsFilter3');
            },

            resetContacts: function() {
                this.contactsFilter = null;
                Event.$emit('vue-tables.filter::contacts', null);
            },
            getStatuses: function(){
                return CONSTANTS.VOUCHER_STATE_NAMES;
            },
            getStatusesTV: function(){
                let statusTV = [];
                for(let i=0; i<CONSTANTS.VOUCHER_STATE_NAMES.length; i++) {
                    statusTV.push({text:CONSTANTS.VOUCHER_STATE_NAMES[i], value:i});
                }
                return statusTV;
            },
            createVoucher: function(){

                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/create')).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success')
                    {
                        this.showMessageVoucherCreated({title:'Путевка '+response.payload+' создана'});
                        this.$refs.vouchersTable.refresh();
                    }
                    else {
                        console.log('response.error', response.error);
                    }
                }, this.httpError);
            },

            deleteVoucher: function (id) {
                this.voucherIdToDelete = id;
                this.deleteModal = true;
            },
            cancelDelete: function () {
                this.voucherIdToDelete = null;
            },
            continueDelete: function () {
                this.deletedVoucherId = this.voucherIdToDelete;
                this.httpPrepare();
                this.$http.delete(this.apiurl('voucher/' + this.voucherIdToDelete + '/delete')).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success')
                    {
                        this.showMessageVoucherDeleted({title:'Путевка '+response.payload+' удалена'});
                        this.$refs.vouchersTable.refresh();
                        //this.voucherIdToDelete = null;
                    }
                    else {
                        console.log(response.body.error);
                    }
                }, this.httpError);
            },

            saveFilter() {
                console.log('saveFilter')
                this.$store.commit('saveFilters', {
                    contactsFilter:this.contactsFilter,
                });
            },

            restoreFilter() {
                this.contactsFilter = this.$store.state.filters.contactsFilter;
                if (!this.contactsFilter) this.contactsFilter=null;

                var table = this.$refs.vouchersTable;
                table.page = 1;
                table.$refs.pagination.Page = 1;
                table.customQueries.contacts = this.contactsFilter;
                table.getData(); // this will send the request
            }
        },
        computed: {
        },
        created: function() {
        },
        mounted: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.restoreFilter();
        },
    };
</script>

<style lang="scss">

</style>
